import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let BusTypeController = {
    list: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-type/list`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-type/create`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-type/edit`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-type/detail/${id}`,
            method: 'GET'
        }, callback)
    }
}

export default BusTypeController
